// helpers to converto dates from ISO to DD.MM.YYYY and back for use with rest routes using c++ functions
import moment from 'moment'

export const datesToIso = (data: any, dateFields: string[]) => {
    dateFields.forEach((field: string) => {
        if (data[field]) {
            data[field] = moment(data[field], 'DD.MM.YYYY').toISOString(true).substring(0, 10)
        }
    })
}

export const datesToDateFormat = (data: any, dateFields: string[]) => {
    dateFields.forEach((field: string) => {
        if (data[field] && data[field] !== '') {
            data[field] = moment(data[field]).format('DD.MM.YYYY')
        } else {
            data[field] = ''
        }
    })
}
